export enum UpdateMissionTypeEnum {
  UpdateMissionBehaviour = 'UPDATE_MISSION/BEHAVIOUR',
  UpdateMissionEnabled = 'UPDATE_MISSION/ENABLED',
  UpdateMissionCuttingHeight = 'UPDATE_MISSION/CUTTING_HEIGHT',
  UpdateMissionSchedule = 'UPDATE_MISSION/SCHEDULE',
  UpdateMissionAugmentByVision = 'UPDATE_MISSION/AUGMENT_BY_VISION',
}
